(function () {

  let lastMainColor = null;
  const MAX_INIT_RETRIES = 40;
  const INIT_RETRY_DELAY = 25;

  const qs = (s, p = document) => p.querySelector(s);
  const qsa = (s, p = document) => Array.from(p.querySelectorAll(s));

  function getMainProductColorLabel() {
    const checked = qs('.variant-picker__option-values input[type="radio"]:checked');
    return checked ? qs(`label[for="${checked.id}"]`) : null;
  }

  function findCardLabelByColor(card, color) {
    return qsa('label[data-color]', card)
      .find(l => (l.dataset.color || '').trim().toLowerCase() === color);
  }

  function triggerCardSwatch(card, input) {
    if (!card || !input) return;

    // Set checked without triggering scroll/click
    input.checked = true;

    // Update highlight class
    const lbl = qs(`label[for="${input.id}"]`, card);
    if (lbl) {
      qsa('label[data-color]', card).forEach(l => 
        l.classList.remove('synced-active', 'is-checked', 'active')
      );
      lbl.classList.add('synced-active', 'is-checked', 'active');
    }

    // Find theme internal swatch-change handler
    const proto = card.constructor?.prototype;
    const handler =
      proto?.onSwatchChanged_fn ||
      proto?.onSwatchChanged ||
      proto?._onSwatchChanged ||
      null;

    const evt = new Event("change", { bubbles: true, cancelable: true });

    if (typeof handler === "function") {
      try {
        handler.call(card, evt, input);
        return;
      } catch (e) { }
    }

    // fallback
    input.dispatchEvent(evt);
  }

  function syncAllProductCards() {
    const mainColor = document.body.dataset.mainColor;
    if (!mainColor) return;

    qsa("product-card").forEach(card => {
      const label = findCardLabelByColor(card, mainColor);
      if (!label) return;

      const input = label.control || qs(`input[id="${label.getAttribute('for')}"]`, card);
      if (!input || input.checked) return;

      triggerCardSwatch(card, input);
    });
  }

  function waitForCardLabels(retries = 0) {
    const ready = qsa('product-card').some(card =>
      card.querySelector('label[data-color]')
    );

    if (ready || retries >= MAX_INIT_RETRIES)
      return syncAllProductCards();

    setTimeout(() => waitForCardLabels(retries + 1), INIT_RETRY_DELAY);
  }

  function initMainColor() {
    const lbl = getMainProductColorLabel();
    if (lbl?.dataset?.color) {
      lastMainColor = lbl.dataset.color.trim().toLowerCase();
      document.body.dataset.mainColor = lastMainColor;
    }
  }

  const debounce = (fn, wait = 40) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };

  const debouncedSync = debounce(syncAllProductCards, 40);

  document.addEventListener('change', (e) => {
    const input = e.target;
    if (!input.matches('.variant-picker__option-values input[type="radio"]')) return;

    const label = qs(`label[for="${input.id}"]`);
    if (!label?.dataset?.color) return;

    const newColor = label.dataset.color.trim().toLowerCase();
    document.body.dataset.mainColor = newColor;

    if (newColor === lastMainColor) return;

    lastMainColor = newColor;
    debouncedSync();

  }, true);

  function initialize() {
    initMainColor();
    waitForCardLabels();
  }

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', initialize);
  else
    initialize();

})();
